import { AlertTriangle } from 'lucide-react'

/**
 * Top-of-page banner shown when the app is built with VITE_EBAY_SANDBOX=true.
 *
 * Why this exists: nothing about the dashboard chrome changes between
 * sandbox and prod, so a seller (or a developer) can lose track of which
 * environment they're testing against. Misdirected publish calls in
 * sandbox = wasted listing slots, missing data; in prod from a sandbox-
 * configured app = real money risk. The banner makes the active
 * environment visually undeniable.
 *
 * Renders nothing in production builds so there's zero runtime cost
 * when the flag isn't set.
 */
export function SandboxBanner() {
  if (import.meta.env.VITE_EBAY_SANDBOX !== 'true') return null

  return (
    <div
      role="status"
      aria-label="eBay sandbox mode active"
      className="flex items-center justify-center gap-2 border-b border-fos-amber bg-fos-amber-bg px-4 py-1.5 text-[12px] font-medium text-fos-amber"
    >
      <AlertTriangle className="h-3 w-3" />
      <span>
        eBay Sandbox mode — listings, orders, and payouts are simulated. Set <code className="rounded bg-fos-bg-base px-1 font-mono text-[11px]">VITE_EBAY_SANDBOX=false</code> for production.
      </span>
    </div>
  )
}
